import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://ee-journey.emergent.host';

export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach correct token based on path
api.interceptors.request.use((config) => {
  const url = config.url || '';
  // Admin routes (anything under /api/admin/* except admin auth registration is also admin)
  if (url.includes('/api/admin')) {
    const adminToken = localStorage.getItem('ee_admin_token');
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else {
    const userToken = localStorage.getItem('ee_user_token');
    if (userToken) config.headers.Authorization = `Bearer ${userToken}`;
  }
  return config;
});

// Optional response error normalization
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err?.response?.data?.detail || err?.response?.data?.message || err.message;
    err.message = typeof detail === 'string' ? detail : err.message;
    return Promise.reject(err);
  }
);

export const API_BASE = BASE_URL;
export default api;
